import styles from './OutlineOnboardingPage.css';
import AppBar from '../../components/shared/AppBar/AppBar';
import Title from '../../components/shared/Typography/Title';
import { renderIf } from '../../utils/render.utils';
import BodyText from '../../components/shared/Typography/BodyText';
import InfoOutlinedIcon from '../../components/shared/Icons/InfoOutlinedIcon';
import List from '../../components/shared/List/List';
import ListItem from '../../components/shared/List/ListItem';
import Button from '../../components/shared/Button/Button';
import { OutlineOnboardingProvider } from './OutlineOnboardingProvider';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useTranslation from '../../localization/i18n.context';
import { useRef, useEffect } from 'preact/hooks';
import useConfig from '../../config/config.context';
import NavigationUtils from '../../utils/navigation.utils';
import Base64Utils from '../../utils/base64.utils';
import CaasLocalStorageKeys from '../../constants/caas.local.storage.keys';

export default function OutlineOnboardingScreen({
  className = '',
  type,
  path,
}) {
  const { t } = useTranslation();
  const backRef = useRef(null);
  const { config, updateStorage } = useConfig();

  const handleCloseClick = () => {
    if (path === undefined || path === '') {
      return NavigationUtils.endFlow();
    }

    return NavigationUtils.navigate(Base64Utils.decode(path), true);
  };

  const handleButtonClick = () => {
    data.ctaAction;
    handleCloseClick();
  };

  useEffect(() => {
    if (type !== undefined) {
      const navigationComponents =
        config.storage[CaasLocalStorageKeys.NAVIGATION_COMPONENTS] ?? [];
      navigationComponents.push(`oo-${type}`);
      updateStorage(
        CaasLocalStorageKeys.NAVIGATION_COMPONENTS,
        navigationComponents,
      );
    }
  }, []);

  const data = OutlineOnboardingProvider(t)[type];
  return (
    <>
      <AppBar
        onCloseClick={handleCloseClick}
        className="fixed-bar"
        closeRef={backRef}
      />
      <div className={styles.content}>
        <div className={styles['feedback-image']}>
          <img src={data.image} width={200} height={200} />
        </div>

        <div className={styles.text}>
          <div className={styles['feedback-title']}>
            <Title text={data.title} className="text-center" />
          </div>
          {renderIf(
            !!data.text,
            <div className={styles['feedback-text']}>
              <BodyText text={data.text} className="text-center" />
            </div>,
          )}
        </div>

        {renderIf(
          !!data.subtitle,
          <div className={styles['feedback-subtitle']}>
            <div className={styles['feedback-subtitle-icon-wrapper']}>
              {data.icon ? data.icon : <InfoOutlinedIcon />}
            </div>
            <BodyText
              className={styles['feedback-subtitle-text']}
              text={data.subtitle}
            />
          </div>,
        )}

        {renderIf(
          data.list && data.list.length > 0,
          <List className={styles.list}>
            {data.list.map((item, index) => (
              <ListItem
                key={index}
                iconStyle={{ alignItems: 'flex-start' }}
                className={styles['list-item']}
                subtitleClassName={styles['list-item-subtitle']}
                {...item}
              />
            ))}
          </List>,
        )}
      </div>

      <div className={`fixed-cta`}>
        <Button
          fullWidth
          onClick={handleButtonClick}
          type={Button.Type.PRIMARY}
        >
          {data.ctaText}
        </Button>
      </div>
    </>
  );
}
